// @flow
import { execute } from 'fg-frontend/src/partialUpdate/partialUpdate';
import closeEsp from 'fg-frontend/webActions/closeEsp';
import goBack from 'fg-frontend/webActions/goBack';
import scrollToHref from 'fg-frontend/webActions/scrollToHref';
import confirmPopup from 'fg-frontend/webActions/confirmPopup';
import passwordStrength from 'fg-frontend/webActions/passwordStrength';
import toggleClass from 'fg-frontend/webActions/toggleClass';

export default (action) => {
    switch (action) {
        case 'execute':
            return execute;
        case 'closeEsp':
            return closeEsp;
        case 'goBack':
            return goBack;
        case 'scrollToHref':
            return scrollToHref;
        case 'passwordStrength':
            return passwordStrength;
        case 'confirmPopup':
            return confirmPopup;
        case 'toggleClass':
            return toggleClass;
        default:
            console.log(`Unknown action`);
            return null;
    }
};




// WEBPACK FOOTER //
// ./fe/web-career/src/js/configureWebActions.js